/* ============================================================
   Поповер контактов на кнопке «Получить консультацию» +
   глобальная делегация кликов:
   - клик по кнопке → открыть/закрыть поповер;
   - клик по элементу [data-form] → открыть форму заявки;
   - клик вне → закрыть поповер;
   - Esc → закрыть и поповер, и форму.
   ============================================================ */
import { byId } from '../dom';
import type { FormControls } from './form';

export function createPopover(form: FormControls): void {
  const wrap = byId('ctaWrap');
  const btn = byId('ctaBtn');

  function setPop(open: boolean): void {
    wrap.dataset.open = open ? '1' : '0';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    setPop(wrap.dataset.open !== '1');
  });

  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;

    // Делегируем открытие формы заявки (карточки услуг, hero CTA).
    const trigger = target.closest<HTMLElement>('[data-form]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      setPop(false);
      form.openForm(trigger.getAttribute('data-form'));
      return;
    }

    if (!wrap.contains(target)) setPop(false);
  });

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      setPop(false);
      form.closeForm();
    }
  });
}
